import { createApi } from '@reduxjs/toolkit/query/react'
import { ARCHIVE_THERAPIST, CHATTER_PEER_ARCHIVE, GUARDIAN_ARCHIVE, MANAGE_PARENT_ARCHIVE, MANAGE_SUPPORT_STAFF_ARCHIVE, MANAGE_TEACHERS_ARCHIVE } from 'config/apiPaths';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"
import { mdtAssessmentApi } from './MDT/assessment';
import { invalidateAPITags } from 'utils/common';

export const archiveApi = createApi({
    reducerPath: 'archiveApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/client",
    }),
    endpoints: (builder) => ({

        // archive Therapist
        archiveTherapist: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${ARCHIVE_THERAPIST}/${id}`
            }),
        }),

        // archive chatter peer
        archiveChatterPeer: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${CHATTER_PEER_ARCHIVE}/${id}`
            }),
        }),

        // archive parents
        archiveParent: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MANAGE_PARENT_ARCHIVE}/${id}`
            }),
        }),

        // archive teachers
        archiveTeacher: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MANAGE_TEACHERS_ARCHIVE}/${id}`
            }),
        }),

        // archive support staff
        archiveSupportStaff: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MANAGE_SUPPORT_STAFF_ARCHIVE}/${id}`
            }),
        }),

        // archive support staff
        archiveClients: builder.mutation({
            query: ({ id, clientType }) => ({
                method: "DELETE",
                url: `/${clientType}/archive/${id}`
            }),
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                invalidateAPITags(queryFulfilled, dispatch, mdtAssessmentApi, ["mdtAssessmentList", "mdtAssessmentDetails"]);
            },
        }),

        // archive guardian
        archiveGuardian: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${GUARDIAN_ARCHIVE}/${id}`
            }),
        }),
    }),
})

export const {
    useArchiveTherapistMutation,
    useArchiveChatterPeerMutation,
    useArchiveParentMutation,
    useArchiveTeacherMutation,
    useArchiveSupportStaffMutation,
    useArchiveClientsMutation,
    useArchiveGuardianMutation

} = archiveApi;